<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <!-- <div class="item">
            <div class="ipt">
              cfd开关：
              <el-switch v-model="cfdSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div> -->

          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对ID"
                clearable
                filterable
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.symbolId"
                  :label="item.symbolName"
                  :value="item.symbolId"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <el-select v-model="tradeSwitch" placeholder="请选择" clearable>
                <el-option
                  v-for="item in tradeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="show('新增')"
              >新增交易对</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column prop="tenantName" label="租户" />
        <el-table-column prop="symbol" label="交易对" />
        <el-table-column label="cfd滑点">
          <template slot-scope="scope">{{ scope.row.cfdSlippage }}</template>
        </el-table-column>

        <el-table-column label="cfd开关">
          <template slot-scope="scope">
            <span>{{ scope.row.cfdSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易开关">
          <template slot-scope="scope">
            <span>{{ scope.row.tradeSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="liquidationFee" label="强平手续费" />
        <el-table-column prop="makerFee" label="maker费率" />
        <el-table-column prop="takerFee" label="take费率" />
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </Pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="700px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="CfdDetail"
          :model="CfdDetail"
          size="medium"
          label-width="160px"
        >
          <el-form-item label="CFD开关" prop="">
            <el-switch v-model="CfdDetail.cfdSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="交易开关" prop="">
            <el-switch v-model="CfdDetail.tradeSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="CFD滑点" prop="">
            <el-input-number
              :precision="6"
              :step="0.000001"
              controls-position="right"
              v-model="cfdTwo"
            ></el-input-number>
            ~
            <el-input-number
              :precision="6"
              :step="0.000001"
              controls-position="right"
              v-model="cfdOne"
            ></el-input-number>
            <div>[0,0.1) 精度6</div>
          </el-form-item>
          <el-form-item label="强平手续费" prop="">
            <el-input-number
              v-model="CfdDetail.liquidationFee"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="maker费率" prop="">
            <el-input-number v-model="CfdDetail.makerFee"></el-input-number>
          </el-form-item>
          <el-form-item label="take费率" prop="">
            <el-input-number v-model="CfdDetail.takerFee"></el-input-number>
          </el-form-item>

          <el-form-item label="交易对ID" prop="" required>
            <el-select
              v-model="CfdDetail.symbolId"
              placeholder="交易对ID"
              clearable
              filterable
            >
              <el-option
                v-for="item in symbolList"
                :key="item.symbolId"
                :label="item.symbolName"
                :value="item.symbolId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="租户" prop="" required>
            <el-select
              v-model="CfdDetail.tenantId"
              placeholder="租户"
              clearable
            >
              <el-option
                v-for="item in tenantList"
                :key="item.id"
                :label="item.tenantName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import api from "./api";
import Pagination from "components/pagination";
import { tenantInfo } from "@/common/publicApi";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // cfdSwitch: false,
      tradeSwitch: "",
      tradeArr: [
        { label: "全部", value: "" },
        { label: "开", value: true },
        { label: "关", value: false },
      ],
      tenantId: "",
      tenantList: [],
      symbolList: [],
      symbolId: "",
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      CfdDetail: {
        cfdSlippage: [0.0, 0.0],
        cfdSwitch: false,
        tradeSwitch: false,
        symbolId: "",
        liquidationFee: "",
        makerFee: "",
        takerFee: "",
        tenantId: "",
      },
      cfdOne: 0,
      cfdTwo: 0,
    };
  },
  computed: {},
  methods: {
    handleSearch() {
      api
        .getContractSymbolPage({
          tenantId: this.tenantId,
          // cfdSwitch: this.cfdSwitch,
          tradeSwitch: this.tradeSwitch,
          symbolId: this.symbolId,
          ...this.pagination,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        let arr = JSON.parse(row.cfdSlippage);
        this.CfdDetail = JSON.parse(JSON.stringify(row));
        this.CfdDetail.createdTime = undefined;
        this.CfdDetail.updatedTime = undefined;
        arr && arr[0] && (this.cfdTwo = arr[0]);
        arr && arr[1] && (this.cfdOne = arr[1]);
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.CfdDetail = {
        cfdSlippage: [0.0, 0.0],
        cfdSwitch: false,
        tradeSwitch: false,
        symbolId: "",
        liquidationFee: "",
        makerFee: "",
        takerFee: "",
        tenantId: "",
      };
      this.cfdOne = 0;
      this.cfdTwo = 0;
    },
    handleSave() {
      if (this.CfdDetail.symbolId == "") {
        return this.$message.error("请选择币种ID");
      }
      if (this.CfdDetail.tenantId == "") {
        return this.$message.error("请选择租户");
      }
      api
        .updateContractSymbol({
          ...this.CfdDetail,
          cfdSlippage: JSON.stringify([this.cfdTwo, this.cfdOne]),
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.title + "成功");
            this.close();
            this.handleSearch();
          }
        });
    },
  },
  mounted() {
    api.getSymbolList().then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.handleSearch();
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
